import { CommonModule } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { LoaderComponent } from '../Component/Loader/loader/loader.component';
import { Subject } from 'rxjs';
import { CommonService } from '../Model/Common/common.service';
import { ComboService } from '../Model/Combo/combo.service';
import { UserMasterService } from '../user-master.service';
import { ToastService, toastTypeEnum } from '../Util/Toast/toast.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TooltipService } from '../Util/Tooltip/tooltip.service';
import { Router } from '@angular/router';
import { SessionService } from '../Util/Session/session.service';

@Component({
  selector: 'app-maxops-menu-rights',
  standalone: true,
  imports: [LoaderComponent, CommonModule, NgSelectModule, FormsModule, DataTablesModule],
  templateUrl: './maxops-menu-rights.component.html',
  styleUrl: './maxops-menu-rights.component.scss'
})
export class MaxopsMenuRightsComponent {

  isDisabled: boolean = false;
  Users = [] as any;
  Tabledata = [] as any;
  user: any = {}

  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;
  dtoptions: DataTables.Settings = {};

  constructor(
    public common: CommonService,
    private comboload: ComboService,
    private usermaster: UserMasterService,
    private toast: ToastService,
    private modalService: NgbModal,
    private tooltip: TooltipService,
    private router: Router,
    private session: SessionService
  ) {
    this.user = session.GetUserDetails();
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit(): void {
    this.ComboLoad('UserMaster');
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }
  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  Detail = {
    UserMasterID: null
  }

  ComboLoad(Combotype: String) {
    this.isDisabled = true;
    this.comboload.ComboLoad({
      'Combotype': Combotype,
    }).subscribe({
      next: (response) => {
        if (Combotype == 'UserMaster') {
          this.Users = response.ComboLoad;
        }
        this.isDisabled = false;
      },
      complete: () => {
        this.isDisabled = false;
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  LoadMaxopsMenuRights(SelectType: String) {
    if (this.Detail.UserMasterID == null) {
      this.toast.show({ message: "Please select user.", type: toastTypeEnum.warning });
      return;
    }
    this.isDisabled = true;
    let payload = {}

    if (SelectType == "SAVE") {
      payload = {
        SelectType: SelectType,
        UserMasterID: this.Detail.UserMasterID,
        MenuID10IsActive: this.Tabledata.find((e: any) => e.PageId == 10)?.isActive,
        MenuID11IsActive: this.Tabledata.find((e: any) => e.PageId == 11)?.isActive,
        MenuID12IsActive: this.Tabledata.find((e: any) => e.PageId == 12)?.isActive,
        MenuID13IsActive: this.Tabledata.find((e: any) => e.PageId == 13)?.isActive,
        By: this.user.UserId
      }
    } else {
      payload = {
        SelectType: SelectType,
        UserMasterID: this.Detail.UserMasterID,
        MenuID10IsActive: false,
        MenuID11IsActive: false,
        MenuID12IsActive: false,
        MenuID13IsActive: false,
        By: this.user.UserId
      }
    }

    this.usermaster.SaveLoadMaxopsMenuRights(payload).subscribe({
      next: (response) => {
        if (SelectType == 'LOAD') {
          this.Tabledata = response.Table;
          this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.destroy();
            this.dtTrigger.next(null);
          });
        } else {
          this.toast.show({ message: "User rights saved.", type: toastTypeEnum.success });
          this.LoadMaxopsMenuRights('LOAD');
        }
        this.isDisabled = false;
      },
      complete: () => {
        this.isDisabled = false;
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  clear() {
    this.Tabledata = [];
    try {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
        this.dtTrigger.next(null);
      });
    } catch (e) { }
  }
}
